/**
 * A UTC offset, in hours.
 *
 * Only an offset — `+01:00`, `-05:30` — parses. A zone NAME ("Europe/Lisbon") yields
 * `NaN`, which every caller then adds to a date and renders as "Invalid Date": a wrong
 * clock is bad, a broken one tells the reader nothing at all. Launchpod stores whichever
 * the writing client sent, so both shapes reach here; UTC is the honest fallback.
 */
export const convertOffsetToHours = (offset: string) => {
  const sign = offset.startsWith('-') ? -1 : 1;
  const [hours, minutes] = offset.slice(1).split(':').map(Number);

  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return 0;

  return sign * (hours + minutes / 60);
};
